"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const features_1 = require("../features");
const common_1 = require("./common");
const session_1 = require("./session");
const asis_1 = require("./asis");
const hybrid_1 = require("./hybrid");
const web_1 = require("./web");
const ccDev_1 = require("./ccDev");
const usd_1 = require("./usd");
const drPicaso_1 = require("./drPicaso");
const drPicasoAsis_1 = require("./drPicasoAsis");
const assisted_1 = require("./assisted");
const contactCenter_1 = require("../contactCenter");
const activeAsyncConnection_1 = require("../activeAsyncConnection");
const utils_1 = require("../utils");
const configureFramework = (bankId, language, { sessionStore, additionalPlugins = [], createAuthoriserPlugin, } = {}) => {
    const appLocale = (0, utils_1.getAppLocaleFromStorage)() ?? language;
    const { HybridSession, Session, AsisSession } = (0, session_1.configureSessions)(sessionStore);
    const { Session: CCDevSession, Authenticator: CCDevAuthenticator } = (0, ccDev_1.configureFramework)();
    const { Session: USDSession, Authenticator: USDAuthenticator, UsdManager } = (0, usd_1.configureFramework)();
    const { Session: DRPicasoSession, Authenticator: DRPicasoAuthenticator, MockUsdManager } = (0, drPicaso_1.configureFramework)();
    const { Session: DRPicasoSessionAsis, Authenticator: DRPicasoAuthenticatorAsis } = (0, drPicasoAsis_1.configureFramework)();
    const { Session: AssistedSession, Authenticator: AssistedAuthenticator } = (0, assisted_1.configureFramework)(UsdManager);
    let session = Session;
    let asyncConnectionMode = activeAsyncConnection_1.AsyncConnectionMode.WEBSOCKET;
    if ((0, features_1.isWebViewPlatform)()) {
        session = HybridSession;
    }
    else if ((0, contactCenter_1.isContactCenter)()) {
        asyncConnectionMode = activeAsyncConnection_1.AsyncConnectionMode.POLLING;
        session = USDSession;
        const contactCenterSessions = [
            {
                verification: contactCenter_1.isDRPicasoRoute,
                session: DRPicasoSession,
            },
            {
                verification: contactCenter_1.isDevelopmentLogicCCRoute,
                session: CCDevSession,
            },
            {
                verification: contactCenter_1.isAssistedLoginRoute,
                session: AssistedSession,
            },
        ];
        contactCenterSessions.every(typeSession => {
            if (typeSession.verification()) {
                session = typeSession.session;
                return false;
            }
            return true;
        });
    }
    const GenericUSDManager = new features_1.GenericUSDManager(MockUsdManager, UsdManager);
    const { API, APICache, Authoriser, EnvVariables, GlobalCache } = (0, common_1.configureCommon)(session, bankId, appLocale, asyncConnectionMode, GenericUSDManager, { additionalPlugins, createAuthoriserPlugin });
    const { Authenticator } = (0, web_1.configureFramework)(Session, Authoriser, appLocale);
    const { Authenticator: HybridAuthenticator } = (0, hybrid_1.configureFramework)(HybridSession);
    const { Authenticator: AsisAuthenticator } = (0, asis_1.configureFramework)(AsisSession);
    const { TimeOut } = (0, common_1.configureTimeout)(session, Authenticator);
    return {
        Session,
        Authenticator,
        HybridSession,
        HybridAuthenticator,
        CCDevSession,
        CCDevAuthenticator,
        USDSession,
        USDAuthenticator,
        DRPicasoSession,
        DRPicasoAuthenticator,
        API,
        APICache,
        Authoriser,
        TimeOut,
        AsisSession,
        AsisAuthenticator,
        DRPicasoSessionAsis,
        DRPicasoAuthenticatorAsis,
        UsdManager,
        AssistedSession,
        AssistedAuthenticator,
        MockUsdManager,
        EnvVariables,
        GlobalCache,
        GenericUSDManager,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map